<script setup lang="ts">
const { isNew, canSwitchLayout } = useLayoutVersion()
const gtm = useGtm()

function setLayoutVersion(value: boolean) {
  isNew.value = value
  gtm?.trackEvent({
    event: 'layout_version_changed',
    nav_version: resolveLayoutVersionNumber(value),
  })
}
</script>

<template>
  <template v-if="canSwitchLayout">
    <v-divider />
    <v-list-item
      :title="isNew ? $t('layout.versionToggle.new') : $t('layout.versionToggle.legacy')"
      data-nav-id="layout_version_toggle"
      @click.prevent="setLayoutVersion(!isNew)"
    >
      <template #append>
        <v-switch
          :model-value="isNew"
          hide-details
          density="compact"
          color="red-600"
          inset
          @click.stop
          @update:model-value="setLayoutVersion($event === true)"
        />
      </template>
    </v-list-item>
  </template>
</template>
